import React, { useMemo } from "react";
import ReusableForm from "../../../../../components/reusable/ReusableForm";

const CreateOffice = ({
    isOpen,
    loading = false,
    error = "",
    options = {},
    initialValues = {},
    isEdit = false,
    onClose,
    onSubmit,
}) => {
    // OPTIONS
    // const countries = options.countries || [];
    // const timezones = options.timezones || [];

    // COUNTRY OPTIONS
    const countryOptions = useMemo(
        () =>
            (options.countries || []).map((country) => ({
                value: country.value,
                label: country.label || country.name || country.value,
            })),
        [options.countries]
    );

    // TIMEZONE OPTIONS
    const timezoneOptions = useMemo(
        () =>
            (options.timezones || []).map((timezone) => ({
                value: timezone.value,
                label: timezone.label || timezone.name || timezone.value,
            })),
        [options.timezones]
    );

    // FORM FIELDS
    const fields = [
        // BASIC INFORMATION
        {
            name: "name",
            label: "Office Name",
            type: "text",
            required: true,
            placeholder: "Enter office name",
        },

        {
            name: "code",
            label: "Office Code",
            type: "text",
            required: true,
            placeholder: "Enter office code",
        },

        {
            name: "description",
            label: "Description",
            type: "textarea",
            required: false,
            placeholder: "Enter office description",
        },

        // ADDRESS
        {
            name: "address_line_1",
            label: "Address Line 1",
            type: "text",
            required: true,
            placeholder: "Enter street address",
        },

        {
            name: "address_line_2",
            label: "Address Line 2",
            type: "text",
            required: false,
            placeholder: "Apartment, suite, building, etc.",
        },

        {
            name: "city",
            label: "City",
            type: "text",
            required: true,
            placeholder: "Enter city",
        },

        {
            name: "state_province",
            label: "State / Province",
            type: "text",
            required: false,
            placeholder: "Enter state or province",
        },

        {
            name: "postal_code",
            label: "Postal Code",
            type: "text",
            required: false,
            placeholder: "Enter postal code",
        },

        {
            name: "country_code",
            label: "Country",
            type: "select",
            required: true,
            placeholder: "Select country",
            options: countryOptions,
        },

        // CONTACT
        {
            name: "phone",
            label: "Phone",
            type: "text",
            required: false,
            placeholder: "Enter office phone number",
        },

        {
            name: "email",
            label: "Email",
            type: "email",
            required: false,
            placeholder: "Enter office email",
        },

        // TIMEZONE
        {
            name: "timezone",
            label: "Timezone",
            type: "select",
            required: true,
            placeholder: "Select timezone",
            options: timezoneOptions,
        },

        // LOCATION
        {
            name: "latitude",
            label: "Latitude",
            type: "number",
            required: false,
            placeholder: "e.g. 23.2599",
        },

        {
            name: "longitude",
            label: "Longitude",
            type: "number",
            required: false,
            placeholder: "e.g. 77.4126",
        },

        // OFFICE TYPE
        {
            name: "is_head_office",
            label: "Head Office",
            type: "checkbox",
            required: false,
        },
    ];

    // SUBMIT
    const handleSubmit = async (data) => {
        const payload = {
            name: data.name?.trim() || "",
            code: data.code?.trim().toUpperCase() || "",
            description: data.description?.trim() || "",
            address_line_1: data.address_line_1?.trim() || "",
            address_line_2: data.address_line_2?.trim() || "",
            city: data.city?.trim() || "",
            state_province: data.state_province?.trim() || "",
            postal_code: data.postal_code?.trim() || "",
            country_code: data.country_code || "",
            phone: data.phone?.trim() || "",
            email: data.email?.trim() || "",
            timezone: data.timezone || "",
            is_head_office: Boolean(data.is_head_office),

            latitude:
                data.latitude !== "" &&
                data.latitude !== null &&
                data.latitude !== undefined
                    ? Number(data.latitude)
                    : null,

            longitude:
                data.longitude !== "" &&
                data.longitude !== null &&
                data.longitude !== undefined
                    ? Number(data.longitude)
                    : null,
        };

        await onSubmit?.(payload);
    };

    // RENDER
    return (
        <>
            {error && isOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: "20px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 2000,
                        maxWidth: "500px",
                        width: "calc(100% - 40px)",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        background: "#fef2f2",
                        color: "#b91c1c",
                        border: "1px solid #fecaca",
                        boxShadow:
                            "0 10px 30px rgba(0,0,0,.12)",
                    }}
                >
                    {error}
                </div>
            )}

            <ReusableForm
                isOpen        = { isOpen }
                onClose       = { onClose }
                title         = {  isEdit ? "Edit Office" : "Create Office"  }
                fields        = { fields }
                initialValues = { initialValues }
                onSubmit      = { handleSubmit }
                submitLabel   = {
                    loading
                        ? "Saving..."
                        : isEdit
                            ? "Update Office"
                            : "Create Office"
                }
            />
        </>
    );
};

export default CreateOffice;
